import { render, staticRenderFns } from "./certificate.vue?vue&type=template&id=d0ea10b6&scoped=true&"
import script from "./certificate.vue?vue&type=script&lang=js&"
export * from "./certificate.vue?vue&type=script&lang=js&"
import style0 from "./certificate.vue?vue&type=style&index=0&id=d0ea10b6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0ea10b6",
  null
  
)

export default component.exports